import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    minWidth: 275,
    width: 'auto',
    padding: theme.spacing(0),
    border: 'none',
    boxShadow: 'none'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    marginBottom: 16,
    fontSize: 18,
  },
  pos: {
    marginBottom: 12,
  },
  section: {
    height: "100%",
    paddingTop: 1,
    borderStyle: 'none'
  },
  weather__icon: {
    width: 80,
    height: 80,
    top: 0,
    transform: 'translateY(0%)',
    left: 0,
  }
}));

function CardCurrentWeatherConditions(props) {
  const { weather } = props;

  const classes = useStyles();   
  
  const DEFAULT_IMAGE="weather-icon-place-holder.webp"

  const imageFallBack = (e) => {
    e.onerror = null; // prevents looping
    e.target.src = DEFAULT_IMAGE;
  }

  const formatDate = (value) => {
    const date = new Date(value)

    const formattedDate = date.toLocaleString("en-US", {})

    return formattedDate;
  }

  return (
    
      <Card className={classes.card}>
        <CardContent>
          <Typography className={classes.title}>
          Current Weather
          </Typography>
          <div>
          <Grid container spacing={1}>
                <Grid item xs={6} sm={3} className={classes.section}>
                    <Card style={{ border: "none", boxShadow: "none" }} >
                      <div style={{ color: "grey", fontSize: 54, textAlign: 'left' }}> {weather.air_temp}
                      <span style={{ color: "grey", fontSize: 24, verticalAlign: 'super' }}> °F</span>
                      </div>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3} className={classes.section}>
                    <Card style={{ border: "none", boxShadow: "none" }} >
                      <div style={{ color: "grey", fontSize: 24, alignItems: 'center', verticalAlign: 'text-botton' }}>
                      {/* <img src={weather.icon} onError={imageFallBack} className={classes.weather__icon}/> */}
                      </div>
                    </Card>
                </Grid>
                <Grid item xs={12} className={classes.section}>
                    <Card style={{ border: "none", boxShadow: "none" }}>
                      <div style={{ color: "grey" }}> Forecast : {weather.short_forecast}</div>
                    </Card>
                </Grid>
                <Grid item xs={12} className={classes.section}>
                    <Card style={{ border: "none", boxShadow: "none" }}>
                      <div >
                      <div style={{ color: "grey" }}> Wind Speed : {weather.wind_speed + " knots"}</div>
                      <div style={{ color: "grey" }}> Wind Direction : {weather.wind_direction}</div>
                      <div style={{ color: "green", maxInlineSize:"200px", fontSize: 10 }}> Updated : {formatDate(weather.date)} </div>
                      </div>
                    </Card>
                </Grid>
            </Grid>
          </div>
        </CardContent>
      </Card>
  

  );
}

CardCurrentWeatherConditions.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default CardCurrentWeatherConditions;
